module.exports = __webpack_public_path__ + "/images/ico-burger-close.0b3b157.svg";